import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import { Modal, Space } from 'antd';
import RequireDesc from './RequireDesc';
function RequireCheck(props) {
    const [open,setOpen] = useState(false)
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bxq_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <RequireDesc 
                    bxq_id={props.bxq_id}
                />           
            </Modal>
        </>
    )
}

export default RequireCheck